import React, { useContext, useEffect, useState } from "react";
import css from "../css/Mywallet.module.css";
import Rightcontainer from "../Components/Rightcontainer";
import { Link, useHistory, useNavigate } from "react-router-dom";
import axios from "axios";
import socket from "../Components/socket";
import { AiOutlineHistory, AiOutlinePlus } from "react-icons/ai";
import { BsWallet2 } from "react-icons/bs";
import io from "../Components/socket";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import Swal from "sweetalert2";
import { FaPlusCircle } from "react-icons/fa";
import { GiWallet } from "react-icons/gi";
import { HiMiniWallet } from "react-icons/hi2";
import { VscReferences } from "react-icons/vsc";
import { apiRequest } from "../store/allApi";

const Mywallet = ({ user }) => {
  // const [user, setUser] = useState();
  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }

  const access_token = localStorage.getItem("token");
  const addsetting = localStorage.getItem("sitSetting");

  const addCaseSetting = JSON.parse(addsetting);
  const udata = localStorage.getItem("udata");
  const profileData = JSON.parse(udata);
  const time = new Date();
  const [transaction, setTransaction] = useState([]);
  const [showNotice, setShowNotice] = useState(true);
  //   const walletUpdate =()=>{
  //  io.emit("getprofile", access_token);
  //   io.on("setProfile", (data) => {
  //     setUser(data);
  //   });
  //   }

  //   useEffect(()=>{
  //     walletUpdate()
  //   },[]);

  // language

  const history = useHistory();
  const handleClick = (e) => {
    if (profileData?.verified === "unverified") {
      e.preventDefault(); // page pe jaane se roke
      Swal.fire({
            icon: "warning",
            html: `
        <h4 style="color:white; margin-bottom:10px;">
          Please complete KYC
        </h4>
        <p style="color:white;">
          You need to complete your KYC before proceeding.
        </p>
      `,
            background: "linear-gradient(135deg, #1e3a8a, #0f172a)",
            confirmButtonText: "Verify Now",
            confirmButtonColor: "#f59e0b",
          }).then((result) => {
            if (result.isConfirmed) {
              history.push("/Profile"); // ✅ redirect
            }
          });
      return;
    }
    history.push("/addcase");
  };

  const Allgames = async (id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `temp/deposite/${id}?page=${1}&_limit=${10}`,
        "GET",
        null,
        headers,
      );
      setTransaction(res.data.ress[0]?.status);
      {
        // console.log(res.data.ress);
      }
    } catch (e) {
      // {}
    }
  };

  const translations = {
    hi: {
      wallet: "वॉलेट",
      history: "इतिहास देखे | ",
      amount: "पैसे जोड़ें | ",
      withdraw: "पैसे निकाले  | ",
      referPerson: "रेफ़रल | ",
    },
    en: {
      wallet: "My Wallet",
      history: "Order History",
      amount: "Add Cash",
      withdraw: "Withdraw",
      referPerson: "Referral",
    },
  };

  const { language } = useContext(LanguageContext);

  // change theme
  const theme = localStorage.getItem("theme");

  const styles = {
    backgroundColor: theme === "light" ? "#fff" : "black",
    color: theme === "light" ? "black" : "#fff",
  };

  const sweetAlert = () => {
    Swal.fire({
      text: "Your Withdrawal request already submited",
      icon: "error",
    });
  };

  useEffect(() => {
    Allgames(profileData?._id);
    // console.log(user)
  }, []);

  useEffect(() => {
    if (!showNotice) return;

    Swal.fire({
      title: "Players कृपया ध्यान दे ‼️",
      titleText: "Players कृपया ध्यान दे ‼️",
      html: `
        <div style="text-align:left; line-height:1.6; color:#111827;">
          <p><strong>जिस अकाउंट से आप वेबसाइट पर Deposit (पैसे जमा) करते हो उसी अकाउंट मैं Withdrawal (निकासी) होगा !</strong></p>
          <p>धन्यवाद 🙏</p>
        </div>
      `,
      icon: "info",
      confirmButtonText: "OK",
      allowOutsideClick: false,
      background: "#ffffff",
      color: "#111827",
      customClass: {
        title: "swal2-title-black",
      },
      didOpen: () => {
        const style = document.createElement("style");
        style.innerHTML = `
          .swal2-title-black {
            color: #000000 !important;
          }
        `;
        document.head.appendChild(style);
      },
    }).then(() => {
      setShowNotice(false);
    });
  }, [showNotice]);

  return (
    <>
      <div className="leftContainer mb_space" >
        <div className={css.wallet_page_new}>

          <div className={css.wallet_title_box}>
            <h2 className={`${css.wallet_main_title} mt-3`}>
              Wallet Balance
            </h2>

            <div className={css.wallet_glow}></div>
          </div>

          {/* Deposit Card */}
          <div
            onClick={handleClick}
            className={`${css.wallet_card} ${css.deposit_card}`}
          >
            <div className={css.wallet_card_top}>

              <div className={css.wallet_left}>
                <div className={css.wallet_amount_row}>
                  <div className={css.wallet_icon_box}>
                    <img src={process.env.PUBLIC_URL + "/images/rupees.png"} alt="" />
                  </div>
                  <div className={css.wallet_amount}>
                    ₹ {user && user.Wallet_balance}
                  </div>
                </div>
                <h6 className={css.wallet_heading}>Deposit Cash</h6>
              </div>

              <button className={`${css.wallet_btn} ${css.add_btn}`}>
                Add Cash
              </button>
            </div>
            <p className={css.wallet_desc}>
              Can be used to play Tournaments &amp; Battles.<br />
              Cannot be withdrawn to Paytm or Bank.
            </p>
          </div>

          {/* Winning Card */}
          <Link
            to="/Withdrawopt"
            className={`${css.wallet_card} ${css.winning_card}`}
          >
            <div className={css.wallet_card_top}>

              <div className={css.wallet_left}>
                <div className={css.wallet_amount_row}>
                  <div className={css.wallet_icon_box}>
                    <img src={process.env.PUBLIC_URL + "/images/rupees.png"} alt="" />
                  </div>
                  <div className={`${css.wallet_amount} ${css.green_text}`}>
                    ₹ {user && user.withdrawAmount}
                  </div>
                </div>
                <h6 className={css.wallet_heading}>Winning Cash</h6>
              </div>

              <button className={`${css.wallet_btn} ${css.withdraw_btn}`}>
                Withdraw
              </button>
            </div>
            <p className={css.wallet_desc}>
              Can be withdrawn to Paytm or Bank. Can be used<br />
              to play Tournaments &amp; Battles.
            </p>
          </Link>

          {/* Deposit Card */}
          {/* <div className="wallet_card deposit_card" >
            <div className="wallet_card_top">
              <div className="wallet_left">
                <div className="wallet_icon_box blue_box">
                  <GiWallet className="wallet_icon" />
                </div>

                <div>
                  <h4 className="wallet_heading">
                    Referral Earning
                  </h4>

                  <div className="wallet_amount">
                    ₹ {user && user.referral_wallet}
                  </div>
                </div>
              </div>

              <button className="wallet_btn add_btn">
                Redeem{" "}
               </button>
            </div>            
          </div> */}

        </div>
        <div className="rightContainer">
          <div>
            <Rightcontainer />
          </div>
        </div>
      </div>
    </>
  );
};
export default Mywallet;
